import { Restaurant } from '@firsttable/types';

export const formatTagsForAnalytics = (tags: Restaurant['cuisines']) => {
  if (!tags?.edges) {
    return {};
  }

  return tags.edges.reduce((acc: Record<string, string[]>, edge) => {
    const { node } = edge;
    if (node?.category && node?.title) {
      const categoryKey = `restaurant_${node.category
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')}`;
      if (!acc[categoryKey]) {
        acc[categoryKey] = [];
      }
      acc[categoryKey].push(node.title);
    }
    return acc;
  }, {});
};
